module.exports = __webpack_public_path__ + "static/media/ins-ld-bg-low.4ae6ecb8.png";